import { __makeTemplateObject, __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import LTCheckbox from '../LTCheckbox/index.js';
import { CheckboxGroup } from '@primer/react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var CheckboxContainer = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n"])));
var CheckBoxGroup = function CheckBoxGroup(_a) {
  var _b = _a.ariaLabelledBy,
    ariaLabelledBy = _b === void 0 ? undefined : _b,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c,
    _d = _a.defaultSelected,
    defaultSelected = _d === void 0 ? [] : _d,
    _e = _a.id,
    id = _e === void 0 ? undefined : _e,
    _f = _a.label,
    label = _f === void 0 ? "" : _f,
    _g = _a.labelClasses,
    labelClasses = _g === void 0 ? "" : _g,
    _h = _a.options,
    options = _h === void 0 ? [] : _h,
    _j = _a.onChange,
    onChange = _j === void 0 ? function () {} : _j,
    _k = _a.visuallyHidden,
    visuallyHidden = _k === void 0 ? false : _k;
  var _l = useState(defaultSelected),
    selectedCheckboxes = _l[0],
    setSelectedCheckboxes = _l[1];
  useEffect(function () {
    if (Array.isArray(defaultSelected)) {
      setSelectedCheckboxes(defaultSelected);
    }
  }, [defaultSelected]);
  function toggleItemInArray(item, options) {
    var index = options.indexOf(item);
    if (index > -1) {
      return options.filter(function (_, i) {
        return i !== index;
      });
    } else {
      return __spreadArray(__spreadArray([], options, true), [item], false);
    }
  }
  var handleCheckboxChange = function handleCheckboxChange(lastSelectedValue) {
    var updatedSelected = toggleItemInArray(lastSelectedValue, selectedCheckboxes);
    setSelectedCheckboxes(updatedSelected);
    onChange(updatedSelected);
  };
  var isChecked = function isChecked(value) {
    return selectedCheckboxes.includes(value);
  };
  return /*#__PURE__*/React.createElement(CheckboxGroup, {
    "aria-labelledby": ariaLabelledBy,
    id: id,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(CheckboxGroup.Label, {
    visuallyHidden: visuallyHidden,
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement(CheckboxContainer, null, options === null || options === void 0 ? void 0 : options.map(function (checkbox, index) {
    var _a = checkbox || {},
      _b = _a.value,
      value = _b === void 0 ? index : _b,
      _c = _a.leadingIcon,
      leadingIcon = _c === void 0 ? null : _c,
      _d = _a.trailingIcon,
      trailingIcon = _d === void 0 ? null : _d;
    return /*#__PURE__*/React.createElement("li", {
      style: {
        marginTop: index !== 0 ? "8px" : ""
      }
    }, /*#__PURE__*/React.createElement(LTCheckbox, __assign({
      key: value,
      leadingIcon: leadingIcon,
      trailingIcon: trailingIcon,
      shouldHighlightLabel: true,
      checked: isChecked(checkbox.value),
      onChange: function onChange(e) {
        return handleCheckboxChange(checkbox.value);
      }
    }, checkbox)));
  })));
};
CheckBoxGroup.propTypes = {
  ariaLabelledBy: PropTypes.string,
  disabled: PropTypes.bool,
  defaultSelected: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  leadingIcon: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  trailingIcon: PropTypes.node,
  visuallyHidden: PropTypes.bool
};
var templateObject_1;

export { CheckBoxGroup as default };
